import './Register.css';
import houseImage from './house.jpg';
import logoImage from './apnaghar.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

const CLOUD_RUN_URL =
  window.location.hostname === 'localhost'
    ? null
    : 'https://apnaghar-server-446361307066.us-central1.run.app/checkIpLimit';

const generateCustomUserId = () =>
  `agh_user_${Math.floor(10000 + Math.random() * 90000)}`;

const fetchUserIP = async () => {
  try {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    return data.ip || 'Unknown';
  } catch (err) {
    console.error('IP fetch error:', err);
    return 'Unknown';
  }
};

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
  });

  const [checkingIP, setCheckingIP] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) =>
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const checkIpLimit = async () => {
    if (!CLOUD_RUN_URL) return true;

    setCheckingIP(true);
    try {
      const resp = await fetch(CLOUD_RUN_URL, { method: 'POST' });
      const data = await resp.json();
      if (!data.allowed) {
        setError('❌ Max 2 accounts per device/IP reached.');
        return false;
      }
      return true;
    } catch {
      setError('❌ Failed to check IP limit.');
      return false;
    } finally {
      setCheckingIP(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const { username, password, confirmPassword } = formData;

    // -------------------
    // 1️⃣ Local validation first
    // -------------------
    if (!username || !password || !confirmPassword) {
      return setError('❌ Please fill all fields.');
    }
    if (password !== confirmPassword) {
      return setError('❌ Passwords do not match.');
    }

    // -------------------
    // 2️⃣ Check IP limit
    // -------------------
    const allowed = await checkIpLimit();
    if (!allowed) return;

    try {
      // -------------------
      // 3️⃣ Google Sign-In first
      // -------------------
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const email = user.email;

      // -------------------
      // 4️⃣ Only now store user data in Firestore
      // -------------------
      const userIP = await fetchUserIP();
      const customId = generateCustomUserId();

      await setDoc(doc(db, 'user-data', user.uid), {
        username: username.trim(),
        email: email,
        customId: customId,
        role: 'user',
        ipAddress: userIP,
        createdAt: serverTimestamp(),
        profilePic: user.photoURL || null,
      });

      setSuccess('🎉 Account created successfully!');
      setTimeout(() => navigate('/homepage'), 1500);


    } catch (err) {
      console.error(err);
      setError('❌ ' + err.message);
    }
  };

  return (
    <div className="register-container">
      <button className="back-btn2" onClick={() => navigate(-1)}>Back</button>

      <div className="register-card">
        <div className="register-left">
          <div className="register-heading">
            <img src={logoImage} className="logo" />
            <h2 className="welcome-title">Welcome to ApkaGhr</h2>
            <p className="welcome-subtitle">Join the family</p>
          </div>

          <form onSubmit={handleRegister}>
            <h1 className="signin-heading">Register</h1>

            <label>Username</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />

            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />

            <label>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />

            {error && <p className="error-msg">{error}</p>}
            {success && <p className="success-msg">{success}</p>}

            <button className="register-btn" disabled={checkingIP}>
              {checkingIP ? 'Checking device...' : 'Continue with Google'}
            </button>

            <p className="signin-link">
              Already registered?{' '}
              <span onClick={() => navigate('/signin')}>Sign In</span>
            </p>
          </form>
        </div>

        <div className="register-right">
          <img src={houseImage} alt="House" />
        </div>
      </div>
    </div>
  );
};

export default Register;
